import { Box, Shimmer } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

const WizardPricingLoading = ({ pdpHeaderPricingExp }) =>
  pdpHeaderPricingExp > 0 ? (
    <Box mb="12px" textAlign={{ _: "center", tablet: "left" }}>
      <Shimmer
        height="32px"
        mb="2px"
        mx={{ _: "auto", tablet: 0 }}
        width="80px"
      />
      <Shimmer height="14px" mx={{ _: "auto", tablet: 0 }} width="280px" />
    </Box>
  ) : (
    <Box textAlign="center">
      <Shimmer
        height="50px"
        mb={{ _: 2, tablet: "10px" }}
        mx="auto"
        width="190px"
      />
      <Shimmer height="12px" mx="auto" width="116px" />
    </Box>
  )

WizardPricingLoading.propTypes = {
  pdpHeaderPricingExp: PropTypes.number,
}

const mapStateToProps = (state) => {
  return {
    pdpHeaderPricingExp: state.experiment.pdpHeaderPricing.variant_id,
  }
}

export default connect(mapStateToProps)(WizardPricingLoading)
